(() => {
  const tableOfContentsLinkClassName = 'js-table-of-contents-item-link';
  const dataTargetId = 'data-target-id';

  const getHeaderHeight = () => {
    const header = document.getElementById('header');
    return header ? header.clientHeight : 0;
  }

  const addHashToUrl = (id) => {
    history.pushState(null, '', `#${id}`);
  };

  const scroll = (targetElement) => {
    const rect = targetElement.getBoundingClientRect();
    const elementTop = rect.top + window.pageYOffset - getHeaderHeight();
    window.scrollTo({
      top: elementTop,
      behavior: 'smooth',
    });
  };

  const init = () => {
    const tableOfContentsLinks = document.getElementsByClassName(tableOfContentsLinkClassName);
    for (const tableOfContentsLink of tableOfContentsLinks) {
      tableOfContentsLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = tableOfContentsLink.getAttribute(dataTargetId);
        if (!targetId) {
          throw new Error('target id is missing');
        }
        const targetElement = document.getElementById(targetId);
        if (!targetElement) {
          throw new Error('target element is missing');
        }
        addHashToUrl(targetId);
        scroll(targetElement);
      });
    }
  };
  window.addEventListener('DOMContentLoaded', init);
})();
